<script setup>
import { ref } from 'vue'
import TitleTwo from '@/components/title-des/titleTwo.vue'

const selected = ref('一库')
const brainData = [
  {
    title: '一库',
  },
  {
    title: '五图',
  },
  {
    title: '六集',
  },
]
const data = [
  {
    title: '链式企业名录',
    text: '实现“强链补链”的精准锚点。',
    des: '基于本地重点产业链的上下游图谱，精准梳理出的、与本地产业存在强关联或强互补关系的域外关键企业名单。不仅包括供应商和客户，还包括技术合作方、平台型企业等。',
  },
  {
    title: '创业企业名录',
    text: '布局“未来之星”的潜力金矿。',
    des: '聚焦于处于快速成长期、赛道前景好、团队背景强、有快速扩张需求的创新型企业。',
  },
  {
    title: '行业协会企业名录',
    text: '切入“产业圈层”的高效路径。',
    des: '展示国家级、省级重点行业协会旗下的会员企业，实现集中触达、主题招商。',
  },
  {
    title: '乡贤企业名录',
    text: '激活“情感纽带”的信任桥梁。',
    des: '梳理统计出的，由本地籍贯企业家在外创办或担任高管的优质企业。',
  },
  {
    title: '校友企业名录',
    text: '撬动“学缘资源”的创新引擎。',
    des: '针对本地高校及知名中学的杰出校友，其创办或管理的科技型、创新型企业。',
  },
  {
    title: '投资机构企业名录',
    text: '借力“资本眼光”的项目捕手。',
    des: '汇集知名VC（风险投资）、PE（私募股权）、产业投资基金及其投资组合企业。通过对接投资机构，实现集中触达、主题招商。',
  },
]
</script>

<template>
  <div class="brainPart w-full">
    <div class="text-[24px] text-[#666] text-left leading-[32px] mt-4 px-4">
      基于IDICC自有产业数据库，客户私有数据库、联网检索数据库三库智能融合，对数据进行过滤，提取真实有价值的数据，并对数据来源实现溯源追踪，确保数据可信、可用、可查;最终调用IDICC专业的图、表、册、数据、知识、政策来生成专业报告。
    </div>
    <TitleTwo title="产研智编AI智能体" top="32px" bottom="16px" sub-title="" />
    <div class="bg-left-right">
      <div
        class="w-full h-[70px] text-[28px] font-bold flex justify-center gap-[96px] pt-4"
      >
        <div
          v-for="brain in brainData"
          :key="brain.title"
          class="h-[606px] relative"
          :class="selected === brain.title ? 'selected' : ''"
          @click="selected = brain.title"
        >
          {{ brain.title }}
          <img
            v-show="selected === brain.title"
            src="https://static.idicc.cn/cdn/official/H5/research_down.png"
            alt=""
            class="w-[21px] h-[14px] absolute top-[40px] left-[20px]"
          >
        </div>
      </div>
      <div v-if="selected === '一库'" class="w-full">
        <div class="content-visualization">
          <div class="viz-placeholder">
            <!-- <span class="viz-text">这里是段动画</span> -->
          </div>
        </div>
      </div>
      <div v-if="selected === '五图'" class="w-full mt-6">
        <img
          src="https://static.idicc.cn/cdn/official/H5/research_5tu.png"
          alt=""
          class="w-full"
        >
      </div>
      <div
        v-if="selected === '六集'"
        class="w-full h-[420px] overflow-x-scroll mt-12"
      >
        <div class="w-[3220px] h-[400px] scrollBar px-[30px] flex items-center">
          <div
            v-for="brain in data"
            :key="brain.title"
            class="w-[520px] h-[400px] brainCards bg-white rounded-[8px] relative"
          >
            <div class="text-[28px] font-bold text-[#333333]">
              {{ brain.title }}
            </div>
            <div class="w-[166px] h-[2px] bg-[#1741CD] my-2" />
            <div class="text-[28px] text-[#666666]">
              <span class="text-[#333] font-bold">{{ brain.text }}</span>{{ brain.des }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.brainPart {
  .bg-left-right {
    width: 100%;
    height: 600px;
    background: center / contain no-repeat
      url("https://static.idicc.cn/cdn/official/H5/research_mian_bg.png");
    background-size: 100%;
  }
  .selected {
    color: #1741cd;
  }

  .brainCards {
    margin-right: 24px;
    padding: 24px;
    box-sizing: border-box;
    border: 2px solid #829cc1;

    .brainCardsDes {
      color: #999999;
      margin-top: 12px;
      padding: 8px 8px 0px 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
.scrollBar {
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}
.content-visualization {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 78px;
}

.viz-placeholder {
  width: 257px;
  height: 450px;
  border-radius: 16px 16px 0 0;
  position: relative;
  background: center / cover no-repeat url("https://static.idicc.cn/cdn/official/web/一库.gif");
}
</style>
